<template>
  <div id="header">
    <nav class="nav">
      <div class="nav-1200">
        <ul class="left-ul">
          <li>
            <!-- <img class="icon" src="../../assets/imgs/apply.png" > -->
            <!-- <span class="iconfont icon-zhiwei"></span> -->
            <span class="iconfont job-icon"></span>
            <router-link to="/jobs">Job Offers</router-link>
            <span class="line">|</span>
          </li>
          <li>
            <!-- <img class="icon" src="../../assets/imgs/phone2.png" /> -->
            <span class="iconfont phone-icon"></span>

            020-26220985
            <span class="line">|</span>
          </li>
          <li>
            <!-- <img class="icon" src="../../assets/imgs/email.png" /> -->
            <span class="iconfont email-icon"></span>

            info@fountain-scientific.com
            <span class="line">|</span>
          </li>
        </ul>
        <div class="loginBox" v-show="!user">
          Welcome to Fountain-Scientific
          <router-link to="login">[Log in]</router-link>
          <router-link to="register">[Sign in]</router-link>
        </div>
        <div class="userBox" v-show="user">
          Dear {{ user }} , welcome to Fountain-Scientific
          <span @click="cancelUser">[Log out]</span>
        </div>
        <ul class="right-ul">
          <li id="user" v-show="user">
            <img src="../../assets/imgs/me.png" class="icon" />
            <router-link to="/me">Basic Info</router-link>
            <!-- <img src="../../assets/imgs/tri.png" class="icon"> -->
            <span class="line">|</span>
          </li>
          <li>
            <img
              src="../../assets/imgs/sm-logo3.png"
              class="icon"
              :style="{ width: '15px', height: '15px' }"
            />
            <router-link to="/"
              >Fountain-Scientific Official Website</router-link
            >
            <span class="line">|</span>
          </li>
          <li>
            <img src="../../assets/imgs/flag.png" class="icon" />
            <router-link to="/about"> About Us </router-link>
          </li>
        </ul>
      </div>
    </nav>
    <div class="h30"></div>
    <div class="tabBox w1200">
      <div class="logoBox" @click="toPage('/')">
        <img :src="imgURL"  />
        <!-- <img src="../../assets/imgs/about-logo.png" alt="" /> -->
      </div>
      <div class="codeBox">
        <img src="../../assets/imgs/code.png" />
      </div>
    </div>
    <div class="searchBox w1200">
      <div class="menuBox">
        <p class="menu-p">
          Products
          <img src="../../assets/imgs/white-tri.png" class="white-tri" />
        </p>
        <div class="show-menu">
          <ul class="first-menu" :class="{ firstShow: isHome }">
            <li
              v-for="(item, index) in proList"
              :key="index"
              @mouseover="
                protab(index);
                addData();
                isFirstMenu();
              "
              @mouseleave="isFirstMenuFlag = false"
              class="firstLi"
            >
              <span>{{ item }}</span>
              <span class="right-tri"></span>
            </li>
          </ul>
          <ul
            class="second-menu"
            v-show="isFirstMenuFlag"
            @mouseover="isFirstMenuFlag = true"
            @mouseleave="isFirstMenuFlag = false"
          >
            <li
              v-for="(item2, index2) in desItem"
              :key="index2"
              class="second-content"
            >
              <div class="second-div">
                <span class="second-t" @click="searchByName(item2)">{{
                  item2
                }}</span>
                <span class="line2">|</span>
              </div>
              <div class="third-div">
                <span
                  class="third-t"
                  @click="searchByName(item3)"
                  v-for="(item3, index3) in thirdItem[index2]"
                  :key="index3"
                >
                  {{ item3 }}
                  <span
                    class="line2"
                    v-show="index3 != thirdItem[index2].length - 1"
                    >|</span
                  >
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="secondBox">
        <div class="search-icon-box">
          <img src="../../assets/imgs/search.png" class="icon search-icon" />
        </div>
      </div>
      <form action="get">
        <div class="mid-search">
          <div class="bar-box">
            <div class="search-key">Search REF</div>
            <input
              type="text"
              v-model="searchData.all"
              placeholder="Please enter the name and type of the product you want to search"
              class="search-input"
            />
            <div class="search-btn" @click="searchByName(searchData.all)">
              Search
            </div>
          </div>
          <div class="bar-box">
            <div class="search-key">Search Term</div>
            <input
              type="text"
              v-model="searchData.name"
              placeholder="Please enter the name of the product you are searching for"
              class="search-input"
            />
            <div class="search-btn" @click="searchByName(searchData.name)">
              Search
            </div>
          </div>
          <ul class="hot">
            <div class="icon p-hot">HOT</div>
            Hot Keywords:
            <li
              v-for="(item, index) in hots"
              :key="index"
              @click="searchByName(item)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
const url = require("../../url").url;
export default {
  props: {
    isHome: {
      default: false,
    },
  },
  data() {
    return {
      //图片url
      imgURL: "",
      //设置默认图片
      logo: 'this.src="' + require("../../assets/imgs/about-logo.png") + '"',
      isFirstMenuFlag: false,
      //判断登陆
      user: "",
      //搜索数据，绑定input
      searchData: {
        name: "",
        all: "",
      },
      hots: ["90mm Petri Dishes", "92mm Petri Dishes", "60mm  Petri Dishes"],
      //产品分类，proList一级菜单，des二级菜单，third三级菜单
      proList: [],
      desItem: "",
      thirdItem: "",
      desIndex: 0,
      data: "",
    };
  },
  methods: {
    isFirstMenu() {
      this.isFirstMenuFlag = true;
    },
    addData() {
      this.desItem = [];
      this.thirdItem = [];
      for (let i = 0; i < this.data.data[this.desIndex].children.length; i++) {
        this.desItem.push(this.data.data[this.desIndex].children[i].class_name);
        this.thirdItem[i] = [];
        for (
          let j = 0;
          j < this.data.data[this.desIndex].children[i].children.length;
          j++
        ) {
          this.thirdItem[i].push(
            this.data.data[this.desIndex].children[i].children[j]
          );
        }
      }
    },
    protab(index) {
      this.desIndex = index;
    },
    searchByName(value) {
      window.localStorage.clear();
      this.isFirstMenuFlag = false;
      let query = {
        keyword: value,
        select: "",
        page: 1,
      };
      this.$router.push({ path: "/search", query });
    },
    toPage(value) {
      this.$router.push(value);
    },
    cancelUser() {
      this.user = "";
      sessionStorage.removeItem("user");
      alert("Success to log out");
    },
    //取得图片
    getImg() {
      let self = this;
      this.$ajax({
        url: "https://fountain-scientific.com/v2/logo",
        type: "GET",
        success: function (data) {
          self.imgURL = data;
        },
        error: function (res) {
          console.log(res);
        },
      });
    },
  },
  mounted: function () {
    let user = sessionStorage.getItem("user");
    if (user) {
      this.user = user;
    }

    var self = this;
    this.$ajax({
      url: "https://fountain-scientific.com/v2/class",
      type: "GET",
      data: "{}",
      success: function (data) {
        self.data = data;
        console.log(data);
        
        // test
        // const testArray = ['Cell/Tissue Culture', 'Microplates', 'Immunology', 'Microbiology/Bacteriology'
        //   ,'Tubes/Multipurpose Beakers', 'Liquid Handling', 'Molecular Biology', 'Separation'
        // ]
        // data.data.forEach((item, index) => {
        //   item.class_name = testArray[index];
        // })

        for (let i = 0; i < data.data.length; i++) {
          self.proList.push(data.data[i].class_name);
        }
      },
      error: function (res) {
        console.log(res);
      },
    });
    this.getImg();
  },
};
</script>
<style lang="less">
@import url("../../assets/css/style.less");

.email-icon::after {
  content: "\e645";
  font-size: 18px;
}

.phone-icon::after {
  font-size: 18px;
  content: "\e683";
}

.job-icon::after {
  content: "\e612";
  font-size: 18px;
}

.iconfont {
  margin-right: 2px;
  color: @indexTheme;
}

::-webkit-scrollbar {
  width: 0px;
}
.h30 {
  height: 30px;
}
#header {
  position: relative;
}
.w1200 {
  width: 80vw;
  margin: 0 auto;
  min-width: 1200px;
}
.t-intro {
  margin-right: 0;
}
/* 头部固定nav条 */
.nav {
  font-size: 13px;
  overflow: hidden;
  box-sizing: border-box;
  position: fixed;
  width: 100%;
  height: 30px;
  line-height: 30px;
  background-color: #f7f7f7;
  border-bottom: 1px #ddd solid;
  z-index: 1500;
}
.nav-1200 {
  width: 80vw;
  margin: 0 auto;
  min-width: 1200px;
  display: flex;
  justify-content: space-between;
}
.userBox > span:hover {
  /* color: red; */
  // color: rgb(11,88,158);
  color: @indexTheme;
}
.left-ul li,
.right-ul li {
  float: left;
}

.left-ul li {
  display: flex;
  align-items: center;
  line-height: 30px;
}

.icon {
  display: inline-block;
  // filter: drop-shadow(10px 0 @indexTheme);
}
.line {
  line-height: 29px;
  color: #c6c6c6;
  margin: 0 10px;
}
.loginBox a {
  /* color: #cd0010; */
  color: @indexTheme;
}

/* logo行 */
.tabBox {
  height: 115px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.logoBox,
.logoBox img {
  width: 500px;
}
.codeBox,
.codeBox img {
  width: 88px;
}

/* 搜索行 */
.searchBox {
  display: flex;
  /* background-color: #e70012; */
  // background-color: rgb(11,88,158);
  background-color: @indexTheme;
  height: 130px;
}
.mid-search {
  margin-top: 15px;
}
/* menu */
.menuBox {
  width: 230px;
}
.menuBox:hover .first-menu {
  display: block;
}
ul.firstShow {
  display: block;
}
.menu-p {
  width: 230px;
  height: 130px;
  line-height: 130px;
  /* background-color: #cd0010; */
  // background-color: rgb(10, 73, 133);
  background-color: @darkTheme;
  color: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-family: "\5FAE\8F6F\96C5\9ED1";
  font-weight: bold;
}
.white-tri {
  width: 9px;
  height: 4px;
}
.show-menu {
  position: relative;
  z-index: 1400;
}
.first-menu {
  background: #fff;
  position: relative;
  border: 1px #d4d4d4 solid;
  display: none;
  padding: 10px 0;
  box-sizing: border-box;
  font-size: 14px;
  height: 345px;
  overflow-y: scroll;
}
.firstLi {
  padding-left: 15px;
  padding-right: 15px;
  text-align: left;
  height: 30px;
  line-height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}
.right-tri {
  width: 7px;
  height: 12px;
  background: url("../../assets/imgs/right-tri.png") no-repeat;
  filter: drop-shadow(-100px 0 @indexTheme);
  position: relative;
  right: -100px;
}
.firstLi:hover {
  /* background-color: #cd0010; */
  // background-color: rgb(11,88,158);
  background-color: @indexTheme;
  color: white;
  cursor: pointer;
}
.firstLi:hover .right-tri {
  /* background: url("../../assets/imgs/right-tri2.png") no-repeat; */
  filter: drop-shadow(-100px 0 #fff);
}

.second-menu {
  position: absolute;
  left: 230px;
  top: 0;
  width: 990px;
  min-height: 430px;
  /* border: 2px #cd0010 solid; */
  border: 2px solid @indexTheme;
  background-color: #ffffff;
  padding: 10px;
  overflow: hidden;
  box-sizing: border-box;
}
.second-menu > li {
  /* height: 18px; */
  line-height: 18px;
  text-indent: 6px;
  color: #3c3c3c;
  font-size: 12px;
  text-align: left;
  /* margin-bottom: 5px; */
}
.line2 {
  color: #c6c6c6;
  margin: 0 5px;
}
.second-t {
  color: #555;
  font-weight: 600;
  margin-right: 5px;
  margin-bottom: 5px;
}
.third-t {
  color: #333;
  margin-right: 5px;
  display: block;
}
.second-t:hover,
.third-t:hover {
  text-decoration: underline;
  cursor: pointer;
}
.second-content {
  display: flex;
  flex-wrap: nowrap;
  font-size: 13px;
  padding: 5px;
}
/* 搜索icon */
.search-icon-box {
  width: 110px;
  line-height: 130px;
}
.search-icon {
  width: 35px;
}
.hot {
  display: flex;
  color: white;
  font-size: 14px;
  margin-top: 10px;
}
.hot li {
  margin-right: 10px;
}
.p-hot {
  /* color: red; */
  color: @indexTheme;
  background-color: #fff;
  font-size: 10px;
  line-height: 20px;
  height: 20px;
  padding: 0 5px;
  margin-right: 10px;
}
.hot > li:hover {
  text-decoration: underline;
}
.bar-box {
  margin-top: 5px;
  display: flex;
  font-size: 12px;
  height: 30px;
  line-height: 30px;
}
.search-input {
  width: 500px;
  text-indent: 6px;
  font-size: 12px;
}
.search-key {
  background: #e4e4e4;
  width: 80px;
  text-indent: 2px;
}
.search-btn {
  color: white;
  font-weight: 600;
  width: 87px;
  /* background-color: #cd0010; */
  background-color: @lightTheme;
}
.third-div {
  display: flex;
  flex-wrap: wrap;
  line-height: 23px;
}
.second-div {
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue